<div class="geral">
  <div class="container__produtos__cs">
    <app-experiencias-produto-cs
      [idMembro]="membro?.idNivel"
      [pontosMembro]="membro?.saldo.saldoPontos"
      [membroCPF]="membro?.cpf"
      [pagina]="this.pagina"
    ></app-experiencias-produto-cs>
  </div>
  <div class="container__conteudo">
    <div class="header">
      <p [ngClass]="{'ajuste--sem--cards': !existeProduto}" class="header__titulo">Descubra todos os momentos especiais</p>
      <div class="campo__pesquisa">
        <button
          class="botao__filtrar"
          (click)="abrirPopupFiltros(true)"
          [ngClass]="{ active: buttonFiltrar }"
        >
          <img
            class="icone__filtro"
            src="assets/images/icons/filter.png"
          /><span class="teste">Filtrar</span>
        </button>

        <div class="input__pesquisa">
          <form (ngSubmit)="aplicarFiltros()" [formGroup]="pesquisaForm">
            <input
              class="pesquisar"
              type="text"
              formControlName="momentoEspecialNome"
              placeholder="Buscar momento especial"
              [(ngModel)]="textoPesquisa"
            /><img
              class="icone__pesquisa"
              src="assets/images/icons/search_regular.png"
              (click)="aplicarFiltros()"
              *ngIf="!loadingAplicar"
            />
            <i
              *ngIf="loadingAplicar"
              class="fa fa-spinner fa-spin loading--input"
            ></i>
          </form>
        </div>
      </div>
    </div>

    <div class="div__filtros_selecionados" *ngIf="buttonFiltrar">
      <p *ngFor="let item of obterFiltrosSelecionados(this.niveisLista)">
        <span *ngIf="item">
          {{ item.nome }}
          <strong (click)="desmarcarItem(item)">X</strong>
        </span>
      </p>
      <p *ngFor="let item of obterFiltrosSelecionados(this.estadosLista)">
        <span *ngIf="item">
          {{ item.nome }}
          <strong (click)="desmarcarItem(item)">X</strong>
        </span>
      </p>
      <p *ngFor="let item of obterFiltrosSelecionados(this.categoriasLista)">
        <span *ngIf="item">
          {{ item.descricao }}
          <strong (click)="desmarcarItem(item)">X</strong>
        </span>
      </p>
      <p *ngIf="this.campanhaSelecionada">
        <span>
          {{ this.campanhaSelecionada.descricao }}
          <strong (click)="this.desmarcarCampanha()">X</strong>
        </span>
      </p>

      <p *ngIf="this.ordemSelecionada">
        <span>
          {{ this.ordemSelecionada.descricao }}
          <strong (click)="this.desmarcarOrdem()">X</strong>
        </span>
      </p>
      <p
        *ngIf="
          this.minValue > this.MIN_VALUE_CACAUS ||
          this.maxValue < this.MAX_VALUE_CACAUS
        "
      >
        <span>
          Valor de cacaus {{ this.minValue }} ~
          {{ this.maxValue >= 150 ? "150+" : this.maxValue }}
          <strong (click)="this.desmarcarRange()">X</strong>
        </span>
      </p>
    </div>

    <div class="body">
      <ngx-skeleton-loader
        class="detalhes__experiencia--loader"
        *ngIf="loadingAplicar"
        count="14"
        [theme]="{
          'border-radius': '15px',
          width: '214px',
          height: '300px',
          margin: '30px 0 10px 0'
        }"
      ></ngx-skeleton-loader>

      <ngx-skeleton-loader
        class="detalhes__experiencia--mobile"
        *ngIf="loadingAplicar"
        count="4"
        [theme]="{
          'border-radius': '15px',
          width: '164px',
          height: '244px',
          margin: '30px 0 10px 10px'
        }"
      ></ngx-skeleton-loader>

      <p class="quantidade__cards" *ngIf="quantidadeCards !== null">
        {{ quantidadeCards }} momentos especiais
      </p>
      <div
        class="cards__momentos__especiais"
        *ngIf="quantidadeCards > 0 && this.membro"
      >
        <app-card-experiencia
          *ngFor="let experiencia of filtrarMomentoPorNome()"
          [id]="experiencia.id"
          [idGrupo]="experiencia.idGrupo"
          [preco]="experiencia.precoEmCacaus"
          [imagemSrc]="experiencia.imagemSrc"
          [titulo]="experiencia.nome"
          [descricao]="experiencia.descricao"
          [validade]="experiencia.dataFim"
          nivel="amor"
          [idNivelExperiencia]="experiencia.idNivel"
          [idNivelMembro]="membro?.idNivel"
          [quantidadeDisponivel]="experiencia.quantidadeDisponivel"
          [tag]="experiencia.tag"
          [destaque]="experiencia.destaque"
          [niveis]="experiencia.experienciaNiveis"
          [nomeIdentificador]="experiencia.nomeIdentificador"
        ></app-card-experiencia>
      </div>
      <div class="sem__momentos__especiais" *ngIf="quantidadeCards == 0">
        <div class="card__sem__momentos">
          <img src="assets/images/icons/moment_notfound.svg" alt="" />
        </div>
        <div class="titulo__sem__momentos">
          <p>Nenhum momento especial foi encontrado</p>
        </div>
        <div class="texto__sem__momentos">
          <p>
            Opa, parece que não foram encontrados nenhum momento especial,
            confira o nome buscado ou os filtros que foram aplicados.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<lovers-popup
  (onClose)="exibirPopup = false"
  [exibir]="exibirPopup"
  tamanho="pequeno"
>
  <div class="geral__filtro">
    <div class="titulo__filtro">
      <p>Filtrar</p>
    </div>

    <div class="campos__filtragem">
      <div class="campo">
        <p class="titulo__campo">
          <img
            class="titulo__icone"
            src="assets/images/icons/heart.png"
          />Niveis
        </p>

        <div class="niveis">
          <div
            class="nivel__opcao"
            *ngFor="let nivel of niveisLista; let i = index"
            (click)="selecionarNivel(i)"
            [ngClass]="{
              'nivel--selecionado': nivel.selecionado,
              'nivel--crush': nivel.id == 5,
              'nivel--paquera': nivel.id == 6,
              'nivel--paixao': nivel.id == 7,
              'nivel--amor': nivel.id == 8
            }"
          >
            <span class="lovers-font--leahlee">{{
              nivel.nome | lowercase
            }}</span>
          </div>
        </div>
      </div>

      <div class="campo">
        <p class="titulo__campo">
          <img
            class="titulo__icone"
            src="assets/images/icons/location-simbol.png"
          />Estado
        </p>

        <div class="lista">
          <div
            class="campo"
            *ngFor="let estado of estadosLista; let i = index"
            (click)="selecionarEstado(i)"
            [ngClass]="{ selecionado: estado.selecionado }"
          >
            <span>{{ estado.nome }}</span>
          </div>
        </div>
      </div>

      <div class="campo">
        <p class="titulo__campo">
          <img
            class="titulo__icone"
            src="assets/images/icons/claquete-escuro.png"
          />Categorias
        </p>
        <div class="lista">
          <div
            class="campo"
            *ngFor="let categoria of categoriasLista; let i = index"
            (click)="selecionarCategoria(i)"
            [ngClass]="{ selecionado: categoria.selecionado }"
          >
            <span>{{ categoria.descricao }}</span>
          </div>
        </div>
      </div>

      <div class="campo">
        <p class="titulo__campo">
          <img
            class="titulo__icone"
            src="assets/images/icons/sticker.png"
          />Campanhas
        </p>
        <div class="lista">
          <div
            class="campo"
            *ngFor="let campanha of campanhasLista"
            (click)="selecionarCampanha(campanha)"
            [ngClass]="{ selecionado: campanha.id == campanhaSelecionada?.id }"
          >
            <span>{{ campanha.descricao }}</span>
          </div>
        </div>
      </div>

      <div class="campo">
        <p class="titulo__campo">
          <img
            class="titulo__icone"
            src="assets/images/icons/outros.png"
          />Ordem
        </p>
        <div class="lista">
          <div
            class="campo"
            *ngFor="let ordem of ordensLista"
            (click)="selecionarOrdem(ordem)"
            [ngClass]="{ selecionado: ordem.id == ordemSelecionada?.id }"
          >
            <span>{{ ordem.descricao }}</span>
          </div>
        </div>
      </div>

      <div class="campo">
        <div class="div__slider_range">
          <div>
            <img class="pontos__icone" src="assets/images/icons/cacau_moeda.png" />
            <p>{{ minValue }}</p>
          </div>
          <ngx-slider
            [(value)]="minValue"
            [(highValue)]="maxValue"
            [options]="options"
          ></ngx-slider>
          <div>
            <img class="pontos__icone" src="assets/images/icons/cacau_moeda.png" />
            <p>{{ maxValue >= 150 ? maxValue + "+" : maxValue }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup__footer popup__filtro">
    <button class="button__limpar__filtro" (click)="limparFiltros()">
      Limpar filtros
    </button>
    <button
      [ngClass]="{ disable: loadingAplicar == true }"
      class="button__aplicar__filtro"
      (click)="aplicarFiltros()"
    >
      Aplicar &nbsp;
      <i *ngIf="loadingAplicar" class="fa fa-spinner fa-spin"></i>
    </button>
  </div>
</lovers-popup>
